<script lang="ts">
  import LanguageSelectView from '../../popups/account/components/LanguageSelectView.svelte';
</script>

<style>
  .wrap {
    box-sizing: border-box;
    width: 320px;
    background: #1A1D1F;
    cursor: default;
    overflow: hidden;
  }
</style>

<div class="wrap p12 T2">
  <LanguageSelectView />
</div>
